// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__20lc0","abort":"style_abort__1CWWA","temporary":"style_temporary__2VCEm","submit":"style_submit__3lqr-"};